

export class UnitDayWeekMonthRequest {
    unitId: string;
    
    groupByCurrentDay: boolean;
    groupByCurrentWeek: boolean;
    groupByCurrentMonth: boolean;

    needInfoForHowManyDeliveryDates: number;
    needInfoForSpecificDeliveryDates: string[];

    constructor( unitId: string, groupByCurrentDay: boolean, groupByCurrentWeek: boolean, groupByCurrentMonth: boolean, needInfoForHowManyDeliveryDates: number, needInfoForSpecificDeliveryDates: string[]) {
        this.unitId = unitId;
        this.groupByCurrentDay = groupByCurrentDay;
        this.groupByCurrentMonth = groupByCurrentMonth;
        this.groupByCurrentWeek = groupByCurrentWeek;
        this.needInfoForHowManyDeliveryDates = needInfoForHowManyDeliveryDates;
        this.needInfoForSpecificDeliveryDates = needInfoForSpecificDeliveryDates;
    }
}


